import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UtilService } from '../../../../../../shared/_services/util.service';
import { LoyaltyService } from '../../../../../../shared/_services/loyalty.service';
import { WindowRef } from '../../../../../../shared/_services/windowRef';
import { HcaUserManagementService } from '../../../../../../shared/_services/hca-user-management.service';
import { HcaBrandService } from '../../../../../../shared/_services/hca-brand.service';
import { HotelManagementService } from '../../../../../../shared/_services/hotel-management.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { StatusModalComponent } from '../../../../../modals/status-modal/status-modal.component';
import { Subscription } from 'rxjs';
import { Subject } from 'rxjs';
import { GetJsonService } from '../../../../../../shared/_services/get-json.service';

@Component({
  selector: 'app-hca-loyalty-website-header-footer',
  templateUrl: './hca-loyalty-website-header-footer.component.html',
  styleUrls: ['./hca-loyalty-website-header-footer.component.scss']
})
export class HcaLoyaltyWebsiteHeaderFooterComponent implements OnInit {
  errorDetails: any;
  successMsg: string;
  isDirtyEn: boolean = false;
  isDirtyEs: boolean = false;
  english: any;
  spanish: any;
  brandInfo: any;
  brand: any;
  languages: any;
  hotelBrands: any;
  nativeWindow: any;
  JSONData: any;
  loyaltyFormEs: FormGroup;
  loyaltyFormEn: FormGroup;
  loyaltyForm: FormGroup;
  private subscription: Subscription;
  headerHtml = "<!---- Template ----> \n\n<nav class='navbar navbar-custom-2 container-fluid'>\n    <div class='navbar-header'>\n      <button type='button' class='navbar-toggle collapsed' data-toggle='collapse' data-target='#navbar-collapse' aria-expanded='false'>\n        <span class='icon-bar'></span>\n        <span class='icon-bar'></span>\n        <span class='icon-bar'></span>\n      </button>\n    </div>\n    <div class='collapse navbar-collapse  navbar-collapse-custom row' id='navbar-collapse'>\n      <div class='col-xs-2'>\n        <!-- <img src='assets/images/icon3.png' /> -->\n        <img src='assets/images/preview-logo.png' />\n      </div>\n      <div class='col-xs-10  top-right-menu'>\n        <ul>\n          <li>HOW IT WORKS</li>\n          <li>SPEND POINTS</li>\n          <li>EARN POINTS</li>\n          <li>MEMBERSHIP</li>\n        </ul>\n      </div>\n    </div>\n  </nav>\n\n<!---- Template ---->";
  headerCss = "/* ------Template ---- */\n\n.navbar-custom-2{\n    min-height: 0px;\n    margin: 0;\n    background: #f37b20;\n    border-radius: 0;\n}\n.navbar-custom-2 .navbar-collapse-custom {\n    width: 100%;\n    padding: 5px 0;\n}\n\n.navbar-custom-2 .navbar-collapse-custom ul {\n    margin: 0;\n    list-style:none;\n}\n\n.navbar-custom-2 .navbar-collapse-custom ul li{\n    display: inline-block;\n    font-size: 13px;\n    color:#fff;\n    padding: 5px 20px;\n}\n\n/* ------Template ---- */";
  footerHtml = "<!---- Template ---->\n\n  <div class=\'container-fluid footer footer-container\'>\n    <div class=\'row\'>\n      <div class=\'col-sm-4\'>\n        <ul>\n          <li>\n            <a class='list-heading'>ABOUT US</a>\n          </li>\n          <li>\n            <a>About Sandos</a>\n          </li>\n          <li>\n            <a>Awards And Recognitions</a>\n          </li>\n        </ul>\n        <ul>\n          <li>\n            <a class='list-heading'>NEWS</a>\n          </li>\n          <li>\n            <a>Blog Sandos</a>\n          </li>\n        </ul>\n        <ul>\n          <li>\n            <a class='list-heading'>SANDOS HOTELS & RESORTS</a>\n          </li>\n          <li>\n            <a>America - Mexico 01 800 907 52 92</a>\n          </li>\n          <li>\n            <a>America - USA 1 866 336 40 83</a>\n          </li>\n          <li>\n            <a>Europa - Español +34 971 78 33 02</a>\n          </li>\n          <li>\n            <a>Europe - UK +44 20 305 137 68</a>\n          </li>\n        </ul>\n      </div>\n      <div class=\'col-sm-4\'>\n        <ul>\n          <li>\n            <a class='list-heading'>SANDOS SMART AGENTS</a>\n          </li>\n          <li>\n            <a>Sandos SMART Agents</a>\n          </li>\n        </ul>\n        <ul>\n          <li>\n            <a class='list-heading'>SANDOS4U</a>\n          </li>\n          <li>\n            <a>Loyalty Program</a>\n          </li>\n        </ul>\n        <ul>\n          <li>\n            <a class='list-heading'>WEDDINGS</a>\n          </li>\n          <li>\n            <a>Plan Your Wedding</a>\n          </li>\n        </ul>\n      </div>\n      <div class=\'col-sm-4\'>\n        <ul>\n          <li>\n            <a class='list-heading'>CONTACT US</a>\n          </li>\n          <li>\n            <a>Send Us A Message</a>\n          </li>\n        </ul>\n        <ul>\n          <li>\n            <a class='list-heading'>NEWSLETTER SIGN-UP</a>\n          </li>\n          <li>\n            <input type='text' placeholder=\'Enter your E-mail address\' class=\'email-ip\'  name='email' value='email' id='emailInput'/>\n            <span id='subscribeLetter'>\n<i class='fa fa-arrow-right hand' aria-hidden='true' id='newsLetter'>\n</i>\n</span>\n          </li>\n          <li class=\'checkbox-conditions\'>\n            <input type='checkbox' class=\'\' name=\'agree\' id=\'agree\'/>\n            <label>I AGREE TO THE CONDITIONS</label>\n        <li>\n<span id='sucessMessage'>\n</span>\n</li> \n <li>\n<span id='errorMessage'>\n</span></li> \n  </li>\n        </ul>\n      </div>\n    </div>\n\n    <div class='row'>\n      <div class='col-xs-12 chats-div'>\n       \n      </div>\n    </div>\n\n    <div class='row'>\n      <div class='col-xs-12 final-div text-center'>\n        &#169;2017 SANDOS HOTELS & RESORTS.ALL RIGHTS RESERVED -\n        <span>TERMS AND CONDITIONS</span>\n      </div>\n    </div>\n  </div>\n   \n<!---- Template ---->";
  footerCss = "/* ------Template ---- */\n\n.footer-container{\n    background: #f5f5f5;\n    font-size: 13px;\n    padding: 12px 15px;\n}\n.footer-container .list-heading{\n    font-size: 13px;\n    font-weight: bold;\n}\n\n.footer-container ul{\n    list-style: none;\n}  \n.footer-container ul li a{\n    color: #0c0033;\n    padding: 5px 0;\n    display: inline-block;\n}\n.footer-container .email-ip{\n    border: none;\n    background: inherit;\n    border-bottom: 2px solid #ccc;\n    padding: 7px 0; \n}\n.footer-container .email-ip:focus{\n    outline: none;\n}\n.footer-container .right-arrow{\n    font-size: 10px;\n    color: #f37b20;\n}\n.footer-container .checkbox-conditions{\n    margin-top: 25px;\n    font-size: 12px;\n    color: #f37b20;\n    \n}\n.footer-container .checkbox-conditions input{\n    margin-right: 10px;\n}\n.footer-container .chats-div{\n    height: 10px;\n    background: #fff;\n}\n.footer-container .final-div{\n    font-size: 10px;\n    opacity: 0.5;\n    font-weight: bold;\n    padding-top:8px;\n}\n.footer-container .final-div span{\n    color: #f37b20;\n    opacity: 1;\n}\n.footer-container .operator_avatar {\n    float: right;\n    border-radius: 50%;\n    width: 4.5em;\n    height: 4.5em;\n    box-shadow: 0 1px 3px rgba(0,0,0,.2);\n    border: .3em solid #fff;\n    box-sizing: content-box;\n    overflow: hidden;\n    color: #fff;\n    text-align: center;\n    position: relative;\n    bottom:30px;\n    transition: background-color .2s ease-in-out .2s;\n    -webkit-transition: background-color .2s ease-in-out .2s;\n    -ms-transition: background-color .2s ease-in-out .2s;\n    -o-transition: background-color .2s ease-in-out .2s;\n    background-color: #f37b20;\n}\n.footer-container .icon-agentonline{\n    font-family: 'livechat-modern' !important;\n    font-style: normal;\n    font-weight: normal;\n    font-variant: normal;\n    text-transform: none;\n    line-height: 1;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n     .fa-arrow-right { \n font-size: 16px; \n color: #f37b20;\n }\n #sucessMessage {\n color: green;\n } \n #errorMessage{ \n color: red \n}\n .footer-container .icon-agentonline:before {\n    content: \'\\e90c\';\n    font-size: 2em;\n}\n  \n/* ------Template ---- */";
  statusModal: BsModalRef;
  private unsubscribe: Subject<void> = new Subject<void>();
  constructor(
    private fb: FormBuilder,
    public translate: TranslateService,
    // private winRef: WindowRef,
    private loyaltyService: LoyaltyService,
    private hcaUserManagementService: HcaUserManagementService,
    private hotelManagementService: HotelManagementService,
    private hcaBrandService: HcaBrandService,
    public modalService: BsModalService,
    public getJsonService: GetJsonService,
  ) {
    // this.nativeWindow = winRef.nativeWindow;
    let user = JSON.parse(localStorage.getItem('loggedInUser'));
    translate.setDefaultLang('en');
    translate.use('en');
    this.modalService.onHide
      .takeUntil(this.unsubscribe).subscribe(res => {
        if (this.statusModal) {
          if (this.statusModal.content.srcObject.type == "hca-wizard") {
            if (this.statusModal.content.srcObject.action == "action1") {
              this.loyaltyFormEn.patchValue(this.loyaltyFormEn.get('resetData').value, { emitEvent: false });
              this.loyaltyFormEs.patchValue(this.loyaltyFormEs.get('resetData').value, { emitEvent: false });
            }
          }
          if (this.statusModal.content.srcObject.type == "hca-header-footer") {
            if (this.statusModal.content.srcObject.action == "action1") {
              if (this.isDirtyEn == true) {
                this.isDirtyEn = false;
                setTimeout(() => {
                  this.getheaderAndFooter(this.brand.brandId);
                  let element = document.getElementById("spanish");
                  element.click();
                }, 50);
              }
              if (this.isDirtyEs == true) {
                this.isDirtyEs = false;
                setTimeout(() => {
                  this.getheaderAndFooter(this.brand.brandId);
                  let element = document.getElementById("english");
                  element.click();
                }, 50);
              }
            }
          }
        }
      })
  }

  getheaderAndFooter(brandId) {
    this.loyaltyService.getHeaderAndFooter(brandId).subscribe(res => {
      console.log('=========== header and footer res ========', res);
      if (res.error == 0) {
        if (res.responseObj && res.responseObj.length) {
          res.responseObj.forEach(data => {
            if (data.languageId == 1) {
              this.initForm(data, 'en');
            }
            if (data.languageId == 2) {
              this.initForm(data, 'es');
            }
          })
        } else {
          this.initForm(null, 'en');
          this.initForm(null, 'es');
        }
      }
    }, err => {
      console.error('Error fetching loyalty website header and footer data', err);
    })
  }

  getHotelBrandsByHotelChain() {
    this.hcaUserManagementService.getHotelBrandsByHotelChain().subscribe(
      res => {
        if (res.error == 0) {
          this.hotelBrands = res.responseObj;
        }
        else {
          console.error("Get Hotel Brands : " + res.message);
        }
      }, err => {
        console.error(err);
      });
  }

  getLanguageCodes() {
    this.hcaBrandService.getLanguageCodes().subscribe(
      res => {
        if (res.error == 0) {
          this.languages = res.responseObj;
          console.log("Get Languages : " + res.responseObj);
          if (res.responseObj.length > 0) {
          }
        }
        else {
          console.error("Get Languages : " + res.message);
        }
      }, err => {
        console.error(err);
      });
  }

  resetField(field?, form?) {
    if (field && form) {
      this[form].controls[field].patchValue(this[form].controls['resetData'].value[field], { emitEvent: false });
    }
  }

  openPreview(langType) {
    var previewWindow = this.nativeWindow.open('/hca-loyalty-website-preview');
    // previewWindow.brandId = this.hotelManagementService.getSelectedBrand().brandId;
    // previewWindow.langType = langType == 'en' ? { languageId: 1, language: 'English' } : { languageId: 2, language: 'Spanish' };
    // previewWindow.headerAndFooter = langType == 'en' ? JSON.stringify(this.loyaltyFormEn.value) : JSON.stringify(this.loyaltyFormEs.value);
    // previewWindow.headerAndFooter = null;

  }

  saveForm() {
    let formData = {
      brandId: this.hotelManagementService.getSelectedBrand().brandId,
      headerFooterToList: [this.loyaltyFormEn.value, this.loyaltyFormEs.value]
    }
    this.loyaltyService.saveLoyaltyWebsite(formData).subscribe(res => {
      console.log(res);
      if (res.responseObj && res.responseObj.headerFooterToList.length) {
        res.responseObj.headerFooterToList.forEach(data => {
          if (data.languageId == 1) {
            this.initForm(data, 'en');
          }
          if (data.languageId == 2) {
            this.initForm(data, 'es');
          }
        })
      }
      this.isDirtyEn = false;
      this.isDirtyEs = false;
      this.successMsg = 'Saved successfully';
      setTimeout(() => {
        this.successMsg = '';
      }, 1000);
    }, err => {
      this.errorDetails = err.message ? err.message : 'Error while saving';
      setTimeout(() => {
        this.errorDetails = '';
      }, 1000);
      console.error('Error saving ', err.message);
    })
  }

  createStyle(css) {
    var css = css,
      head = document.head || document.getElementsByTagName('head')[0],
      style: any = document.createElement('style');

    style.type = 'text/css';
    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }

    head.appendChild(style);
  }

  initForm(data?: any, lang?) {
    if (lang == 'en') {
      let defaultData = {
        headerHtml: this.headerHtml,
        headerCss: this.headerCss,
        footerHtml: this.footerHtml,
        footerCss: this.footerCss
      }
      this.loyaltyFormEn = this.fb.group({
        languageId: [1],
        headerHtml: [data ? data.headerHtml : this.headerHtml],
        headerCss: [data ? data.headerCss : this.headerCss],
        footerHtml: [data ? data.footerHtml : this.footerHtml],
        footerCss: [data ? data.footerCss : this.footerCss],
        resetData: [data ? data : defaultData]
      })
      this.loyaltyFormEn.valueChanges.subscribe(data => {
        if (this.loyaltyFormEn.dirty) {
          this.isDirtyEn = true;
          console.log("en dirty " + this.isDirtyEn);
        }
        else {
          this.isDirtyEn = false;
        }
      });
    }
    if (lang == 'es') {
      let defaultData = {
        headerHtml: this.headerHtml,
        headerCss: this.headerCss,
        footerHtml: this.footerHtml,
        footerCss: this.footerCss
      }
      this.loyaltyFormEs = this.fb.group({
        languageId: [2],
        headerHtml: [data ? data.headerHtml : this.headerHtml],
        headerCss: [data ? data.headerCss : this.headerCss],
        footerHtml: [data ? data.footerHtml : this.footerHtml],
        footerCss: [data ? data.footerCss : this.footerCss],
        resetData: [data ? data : defaultData]
      })
      this.loyaltyFormEs.valueChanges.subscribe(data => {
        if (this.loyaltyFormEs.dirty) {
          this.isDirtyEs = true;
          console.log("es dirty " + this.isDirtyEs);
        }
        else {
          this.isDirtyEs = false;
        }
      });
    }
    this.createStyle(this.headerCss);
  }
  cancel(language) {
    let title = "";
    let status = "";
    let message = "";
    let action1 = "";
    let action2 = "";
    if (language == "english") {
      title = this.english.MODAL.CONFIRM;
      status = this.english.MODAL.ACTIVE;
      message = this.english.MODAL.NOT_SAVED;
      action1 = this.english.MODAL.YES;
      action2 = this.english.MODAL.NO;
    }
    else {
      title = this.spanish.MODAL.CONFIRM;
      status = this.spanish.MODAL.ACTIVE;
      message = this.spanish.MODAL.NOT_SAVED;
      action1 = this.spanish.MODAL.YES;
      action2 = this.spanish.MODAL.NO;
    }

    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hca-header-footer',
      title: title,
      status: status,
      message: message,
      action1: action1,
      action2: action2,
      action: '',
      style: 'active'
    }
  }

  ngOnInit() {
    this.getHotelBrandsByHotelChain();
    this.getLanguageCodes();
    this.subscription = this.loyaltyService.brandState
      .subscribe((state: any) => {
        this.brand = state.brand;
        this.getheaderAndFooter(this.brand.brandId);
      });
    this.initForm(null, 'en');
    this.initForm(null, 'es');

    this.getEnglishTranslations();
    this.getSpanishTranslations();

  }
  getEnglishTranslations() {
    this.getJsonService.getJSON("../assets/i18n/", "en.json")
      .subscribe(
      (res) => {
        this.english = res;
        console.log("English Translations: " + res);
      },
      (err) => console.error("English Translations" + err));

  }
  getSpanishTranslations() {
    this.getJsonService.getJSON("../assets/i18n/", "es.json")
      .subscribe(
      (res) => {
        this.spanish = res;
        console.log("Spanish Translations: " + res);
      },
      (err) => console.error("Spanish Translations" + err));
  }
  initialise() {
    if (this.isDirtyEn == true) {
      this.cancel("english");
    }
    else if (this.isDirtyEs == true) {
      this.cancel("spanish");
    }
  }

  ngAfterViewInit() {
    this.brand = this.hotelManagementService.getSelectedBrand();
    this.getheaderAndFooter(this.brand ? this.brand.brandId : null);
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/settings/hca-loyalty-website/hca-loyalty-website-header-footer/hca-loyalty-website-header-footer.component.ts